import { sizes } from "../styles/sizes";

export const getScreenSize = () => {
    if (window.innerWidth > sizes.large) return 'large';
    else if (window.innerWidth > sizes.medium) return 'medium';
    else return 'small';
};
